import React, { Fragment, useState } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Packages from '../../components/Packages/WebDesignPackages';
import web_video from "../../images/website_design/web_video.mp4";
import WebsiteDesign1 from "../../images/website_design/1.png"
import WebsiteDesign2 from "../../images/website_design/2.png"
import WebsiteDesign3 from "../../images/website_design/3.png"
import WebsiteDesign4 from "../../images/website_design/4.png"
import WebsiteDesign5 from "../../images/website_design/5.png"
import WebsiteDesign6 from "../../images/website_design/6.png"
import WebsiteDesign7 from "../../images/website_design/7.png"
import WebsiteDesign8 from "../../images/website_design/8.png"
import WebsiteDesign9 from "../../images/website_design/9.png"
import half_web_1 from "../../images/website_design/half_web_1.png";
import half_web_2 from "../../images/website_design/half_web_2.png";
import WebDesignTestimonial from '../../components/Testimonials/WebDesignTestimonial';
import { Link } from 'react-router-dom'
import Bg from '../../images/shapes/memecoin_bg_shape_1.svg'
import Bg2 from '../../images/shapes/btn_mask_bg.png'
import shape3 from '../../images/shapes/shape_chain_1.svg'
import shape4 from '../../images/shapes/shape_chain_2.svg'
import Modal from '../../components/Modal/Modal';

const WebsiteDesignPage = () => {
    const [readMore, setReadMore] = useState(false);

    const fullText = `
    Every business nowadays is required to have a strong online portfolio. It has become a necessity for every brand to have a modern, sleek, and unique website in order to gain digital recognition through a brand website. Sometimes it can be hard to find the perfect web design service, and here comes GetLogoAndWebsite to the rescue. We offer web design services and help brands grow worldwide. Whether you are looking for a unique website, an e-commerce platform, or a website for any brand, our team will handle it all perfectly. We go beyond our limits to deliver results that are actually beneficial for your brand. Our company offers web design services that boost your online sales and give customers the perfect website experience. We create websites that satisfy every aspect of customers. Our specialized web services are created to satisfy the particular requirements of your company. We are aware that every brand faces unique requirements and difficulties. Our team works closely with you to comprehend your vision, goals, and functional requirements in order to develop a unique online solution that reflects your brand identity. We keep up with the latest trends to ensure that your website has all the newest and most advanced features. Our main goal is to deliver a smooth and collaborative experience. Invest in web development from GetLogoAndWebsite to boost your company's online presence. Our aim is to fulfill your aspirations. We have the expertise to help you at every step, whether you are a startup hoping to have a big impact or an established business looking to improve your online presence. To embark on an exciting web development adventure that will transform your business, get a free quote now and let us handle the rest!
  `;

    const truncatedText = fullText.slice(0, 600);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    return (
        <Fragment>
            <div className='index_memecoin page_wrapper'>
                <Header />
                <main className="page_content">

                    {/* Hero */}

                    <section className="memecoin_hero_section section_decoration text-center" style={{ backgroundImage: `url(${Bg})` }}>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-12">
                                    <h1 style={{ fontSize: '4rem' }} className="hero_title text-uppercase" data-aos="fade-up" data-aos-duration="800">
                                        PERFECT <mark>SOLUTION</mark> FOR <mark>WEBSITE</mark> DESIGN PROBLEMS
                                    </h1>
                                    <p className="hero_description" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                        In need of professional web design services? Our team is always here to help you stand out online. We make stunning and user-friendly websites according to your brand and goals.
                                    </p>
                                    <ul className="btns_group unordered_list justify-content-center p-0" data-aos="fade-up" data-aos-duration="800" data-aos-delay="200">
                                        <li>
                                            <button className="memecoin_btn bg-light" onClick={openModal}>
                                                <span className="btn_label">Get a Free Quote</span>
                                                <span className="btn_bg" style={{ maskImage: `url(${Bg2})` }}></span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="decoration_item shape_chain_1">
                            <img src={shape3} alt="Shape Chain" />
                        </div>
                        <div className="decoration_item shape_chain_2">
                            <img src={shape4} alt="Shape Chain" />
                        </div>
                    </section>


                    <section id="id_token_offer" className="memecoin_countdown_section section_decoration mt-5 pt-5">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <video muted autoPlay loop preload="none">
                                        <source src={web_video} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                                <div className="col-lg-6">
                                    <div className="memecoin_heading_block" data-aos="fade-up" data-aos-duration="800">
                                        <h2 className="heading_text text-uppercase pt-4">
                                            Pro Development Services
                                        </h2>
                                        <p className="heading_description mb-0 pe-lg-5">
                                            {readMore ? fullText : truncatedText}
                                            {!readMore && "... "}
                                            <span
                                                onClick={() => setReadMore(!readMore)}
                                                style={{ color: "#007bff", cursor: "pointer" }}
                                            >
                                                {readMore ? " Read Less" : " Read More"}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <section
                        id="id_memecoin_service_section"
                        className={`memecoin_service_section z-2 position-relative`}
                    >
                        <div className="container">
                            <div className="memecoin_heading_block text-center">
                                <h2 className="heading_text text-uppercase mb-0">
                                    About Our Web Design Service
                                </h2>
                                <p className='mt-4'>
                                    GetLogoAndWebsite is proud to offer the best and most outstanding web design services with creativity and excellence. A website can act as a powerful tool to express your brand work clearly and wisely. Through a modern website, you can engage with your audience and promote the company's success. At GetLogoAndWebsite, we think that a great website should function flawlessly in addition to looking great. Because a pretty website is useless if it doesn't aid in your growth, we concentrate on designing designs that are aesthetically pleasing, simple to use, and built to perform. For us, having a website is not enough; it's also about having the perfect one.
                                </p>
                            </div>

                            <div className="row">
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={WebsiteDesign1} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={WebsiteDesign2} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={WebsiteDesign3} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={WebsiteDesign4} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <div className="memecoin_iconbox_block">
                                        <img src={WebsiteDesign5} alt="website design" />
                                    </div>
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={WebsiteDesign6} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={WebsiteDesign7} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={WebsiteDesign8} alt="website design" />
                                </div>
                                <div className="col-lg-4" data-aos="fade-up" data-aos-duration="800" data-aos-delay="100">
                                    <img src={WebsiteDesign9} alt="website design" />
                                </div>
                            </div>
                        </div>
                    </section>




                    <section id="id_token_offer" className="memecoin_countdown_section section_decoration">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <div className="memecoin_heading_block" data-aos="fade-up" data-aos-duration="800">
                                        <h2 className="heading_text text-uppercase">
                                            E-Commerce Website Development Services
                                        </h2>
                                        <p className="heading_description mb-0 pe-lg-5">
                                            Our team of experts knows how important it is to stay ahead in the e-commerce world, which is very competitive. We work hard to come up with new ideas that will work for you now and in the future. We make sure that your customers can pay easily and safely by using payment gateways that are safe and reliable. This builds trust and loyalty. Our systems for managing inventory make things easier by letting us easily keep track of and restock items. We make interfaces that are easy to use and make customers happy, which makes them want to come back. Our adaptive design also makes sure that your browsing experience is smooth on all devices, which increases your reach and engagement. We put quality first at every stage to give your business a strong online presence that boosts growth and profits.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-6 d-flex gap-3">
                                    <img src={half_web_1} alt="half_web_1" />
                                    <img src={half_web_2} alt="half_web_2" />
                                </div>
                            </div>
                        </div>
                    </section>

                    <Packages />
                    <WebDesignTestimonial />

                </main>
                <Footer />
                <Scrollbar />
            </div>
            {isModalOpen && <Modal onClose={closeModal} />}
        </Fragment>
    )
};
export default WebsiteDesignPage;